import { createSelector } from 'reselect';
import { initialState } from './reducer';
import { COMPANIES_DOMAIN } from './constants';

const selectCompaniesDomain = state => state[COMPANIES_DOMAIN] || initialState;

export const selectCompanies = () => createSelector(selectCompaniesDomain, d => d.companies);

export const selectCompany = id =>
  createSelector(selectCompaniesDomain, d => d.companies.find(item => item.id === parseInt(id, 10) || item.id === id));

export const selectDuplicateVatCompany = () =>
  createSelector(selectCompaniesDomain, d => d.duplicateVatCompany);

export const selectHomeCompany = () =>
  createSelector(selectCompaniesDomain, d => {
    let homeId = d.homeCompanyId ? d.homeCompanyId : JSON.parse(localStorage.getItem('home-company-id'));
    return homeId;
  });

export const selectCompanyCount = () => createSelector(selectCompaniesDomain, d => d.companiesCount);

export const selectCompanyPaginator = () => createSelector(selectCompaniesDomain, d => d.paginator);

export const selectCompanyPropertyNames = () => createSelector(selectCompaniesDomain, d => d.propertyNames);

export const selectCountries = () =>
  createSelector(selectCompaniesDomain, d => {
    let countries = d.countries ? d.countries : JSON.parse(localStorage.getItem('countries'));
    return countries;
  });

export const selectNewCompanyValue = name =>
  createSelector(selectCompaniesDomain, d => {
    if (name === 'fullname') {
      const name = d.newCompany['name'] ?? '';
      const surname = d.newCompany['surname'] ?? '';
      const fullname = `${name} ${surname}`.trim();
      return fullname;
    }
    return d.newCompany[name];
  });

export const selectNewCompany = () => createSelector(selectCompaniesDomain, d => d.newCompany);

export const selectNewCompanyAddresses = () => createSelector(selectCompaniesDomain, d => d.newCompany.addresses);

export const selectCompanyFilter = () => createSelector(selectCompaniesDomain, d => d.filter);
export const selectFilterSingleValue = name =>
  createSelector(selectCompanyFilter, d => d?.properties?.find(f => f.key === name)?.value?.[0] ?? null);
export const selectFilterValues = name =>
  createSelector(selectCompanyFilter, d => d?.properties?.find(f => f.key === name)?.value ?? []);

export const selectMainFormFlag = () => createSelector(selectCompaniesDomain, d => d.isMainForm);

export const selectCompanyProperty = (companyId, propertyName) =>
  createSelector(selectCompaniesDomain, d => d.companyProperties?.[companyId]?.[propertyName]);

export const selectParentCompany = id => createSelector(selectCompany(id), d => d?.companies?.parentCompanies[0]);

export const selectParentCompanyName = id =>
  createSelector(selectParentCompany(id), d =>
    d ? d.name ?? d.properties?.find(p => p?.name?.name === 'name')?.value : '',
  );

export const selectIbanCheckResult = companyId =>
  createSelector(selectCompaniesDomain, d => (d.ibanCheckResults ?? {})[`${companyId}`]);

export const selectNotification = () => createSelector(selectCompaniesDomain, d => d.notification);

export const selectCompanyDunIdByName = companyId => createSelector(selectCompaniesDomain, d => d.dunIdByName[companyId]);

export const selectCompanyWorkflows = () => createSelector(selectCompaniesDomain, d => d.companyWorkflows);

export const selectCompaniesBulkActionsList = () => createSelector(selectCompaniesDomain, d => d.companyBulkActionsList);

export const selectCompanyHistoryLogs = () => createSelector(selectCompaniesDomain, d => d.historyLogs);
export const selectCompanyFilterHistoryLogs = () => createSelector(selectCompaniesDomain, d => d.filterHistoryLogs);
